// Version checker utility
// MANUAL STEP: Update this version number EVERY TIME before deploying to Heroku
const APP_VERSION = '1.0.2'; // ⚠️ CHANGE THIS NUMBER before deploying!
const VERSION_KEY = 'app_version';
const LAST_UPDATE_CHECK_KEY = 'last_update_check';

class VersionChecker {
  static async checkForUpdates() {
    try {
      const currentVersion = localStorage.getItem(VERSION_KEY);
      const lastCheck = localStorage.getItem(LAST_UPDATE_CHECK_KEY);
      const now = Date.now();
      
      // Don't check too frequently (once every 30 minutes max)
      if (lastCheck && (now - parseInt(lastCheck)) < 30 * 60 * 1000) {
        return { hasUpdate: false, currentVersion: currentVersion || APP_VERSION };
      }
      
      localStorage.setItem(LAST_UPDATE_CHECK_KEY, now.toString());
      
      if (!currentVersion) {
        // First time user
        localStorage.setItem(VERSION_KEY, APP_VERSION);
        return { hasUpdate: false, currentVersion: APP_VERSION };
      }
      
      if (currentVersion !== APP_VERSION) {
        // New version detected
        console.log(`🚀 Update detected: ${currentVersion} → ${APP_VERSION}`);
        return { 
          hasUpdate: true, 
          oldVersion: currentVersion, 
          newVersion: APP_VERSION 
        };
      }
      
      return { hasUpdate: false, currentVersion: APP_VERSION };
    } catch (error) {
      console.error('Error checking version:', error);
      return { hasUpdate: false, currentVersion: APP_VERSION };
    }
  }
  
  static updateVersion() {
    localStorage.setItem(VERSION_KEY, APP_VERSION);
    console.log(`✅ Version updated to: ${APP_VERSION}`);
  }
  
  static getCurrentVersion() {
    return localStorage.getItem(VERSION_KEY) || APP_VERSION;
  }
  
  static clearVersion() {
    localStorage.removeItem(VERSION_KEY);
    localStorage.removeItem(LAST_UPDATE_CHECK_KEY);
  }
  
  // Force check ignoring the time limit
  static forceCheck() {
    localStorage.removeItem(LAST_UPDATE_CHECK_KEY);
    return this.checkForUpdates();
  }
}

export default VersionChecker;
export { APP_VERSION };